"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = require("debounce");
var composition_api_1 = require("@vue/composition-api");
exports.default = composition_api_1.defineComponent({
    name: "WokFacetedSearchBar",
    props: {
        facets: {
            type: Array,
            default: function () { return []; }
        },
        query: {
            type: Object,
            default: function () { }
        },
        debounceInterval: {
            type: Number,
            default: 500
        }
    },
    model: { prop: 'query', event: 'update:query' },
    setup: function (props, ctx) {
        var form = composition_api_1.computed(function () {
            var o = {};
            for (var _i = 0, _a = props.facets; _i < _a.length; _i++) {
                var f = _a[_i];
                o[f.name] = props.query[f.name] || null;
            }
            return o;
        });
        var emitUpdateQuery = function (name, value) {
            form.value[name] = value;
            ctx.emit('update:query', form.value);
        };
        var emitUpdateQueryDebounced = composition_api_1.computed(function () {
            if (props.debounceInterval > 0) {
                return debounce_1.debounce(emitUpdateQuery, props.debounceInterval);
            }
            else {
                return emitUpdateQuery;
            }
        });
        return function () {
            var facetsComponent = props.facets.map(function (x) {
                var _a, _b;
                if (x.type == 'text') {
                    return composition_api_1.createElement('WokInputText', {
                        props: {
                            value: form.value[x.name],
                            label: x.label
                        },
                        on: (_a = {},
                            // Debounce events on text facets because the user usually wants
                            // to search with a string not just a single character.
                            _a['update:value'] = function (evt) { return emitUpdateQueryDebounced.value(x.name, evt); },
                            _a)
                    });
                }
                if (x.type == 'single-choice') {
                    return composition_api_1.createElement('WokSelectNative', {
                        props: {
                            value: form.value[x.name],
                            label: x.label,
                            options: x.options,
                            type: x.optionsType || 'string'
                        },
                        on: (_b = {},
                            // Note that we don't debounce a single choice, no need for it.
                            _b['update:value'] = function (evt) { return emitUpdateQuery(x.name, evt); },
                            _b)
                    });
                }
            });
            return composition_api_1.createElement('WokForm', {}, [composition_api_1.createElement('WokFormRow', {}, facetsComponent)]);
        };
    }
});
